import * as React from 'react';

import WorkEvidenceApproval from '../../../components/WorkEvidence/WorkEvidenceApproval';

export default function WorkEvidenceApprovalPage(): React.JSX.Element {
    return <WorkEvidenceApproval/>;
}